import ConfigService from "./configurationService";
import RunConfigService from "./runConfigService";
import axios from 'axios';

var THIRTY_MIN = 1000 * 60 * 30;

export default {
    getDowntimeStatus
}

async function getDowntimeStatus() {
    let downtime = await _getDowntime(),
        now = Date.now(),
        retVal = {isDown: false, downInMinutes: -1};

    if (downtime && downtime.downTimeStart && downtime.downTimeEnd) {
        retVal.isDown = now >= downtime.downTimeStart && now < downtime.downTimeEnd;
        if (!retVal.isDown && downtime.downTimeStart < (now - THIRTY_MIN)) {
            retVal.downInMinutes = Math.ceil((downtime.downTimeStart - now) / 1000 / 60);
        }
    }

    return retVal;
}

async function _getDowntime() {
    let marketConfig = ConfigService.getMarketConfig(),
        response = await axios({
            url: `${marketConfig.awsUrl}/downtime/v1/${RunConfigService.getRunConfig().country}`,
            method: 'GET',
            headers: {
                'client_id': marketConfig.checkout.clientId,
                'client_secret': marketConfig.checkout.clientSecret
            }
        });

    return response.data.DowntimeList[0];
}


//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/downtimeService.js
// module id = 314
// module chunks = 0